// Copyright (c) Docugami, Inc. All rights reserved.

import { DropTypes, DndItem } from "components/cards/DndTypes";
import { ConnectDropTarget, useDrop } from "react-dnd";

interface DropTargetActive {
    isActive: boolean;
}

export interface IDropTargetWithTrigger {
    triggerRef: ConnectDropTarget;
    dropTargetRef: ConnectDropTarget;
    isVisible: boolean;
    isOver: boolean;
}

export interface DropTargetWithTriggerProps {
    dropTypes: DropTypes;
    onDrop: (item: DndItem) => void;
    canDrop?: (item: DndItem) => boolean;
}

export function useDropWithTrigger(props: DropTargetWithTriggerProps): IDropTargetWithTrigger {
    const { dropTypes, canDrop, onDrop } = props;

    const [{ isActive: isTriggerActive }, triggerRef] = useDrop<DndItem, any, DropTargetActive>({
        accept: dropTypes,
        collect: m => ({
            isActive: !!m.isOver() && !!m.getItem() && !!(canDrop?.(m.getItem()!) ?? true)
        })
    });

    const [{ isActive: isTargetActive }, targetRef] = useDrop<DndItem, any, DropTargetActive>({
        accept: dropTypes,
        canDrop: (item, m) => canDrop?.(item) ?? true,
        drop: (item, m) => onDrop(item),
        collect: m => ({
            isActive: !!m.isOver() && !!m.getItem() && !!(canDrop?.(m.getItem()!) ?? true)
        })
    });

    return {
        triggerRef: triggerRef,
        dropTargetRef: targetRef,
        isVisible: isTriggerActive,
        isOver: isTargetActive
    };
}
